import {Marker as MapMarker} from 'react-map-gl';
import classNames from 'classnames';
import Label from '@spothero/ui/label';
import Sprite from '@spothero/ui/sprite';
import PropTypes from 'prop-types';
import React from 'react';

const Point = (x, y) => ({x, y});

const markerConfig = {
    config: {
        disabled: {
            default: {sprite: 'sm-disabled', offset: Point(6, 13)},
            hover: {sprite: 'md-disabled', offset: Point(20, 49)},
        },
        medium: {
            default: {sprite: 'md', offset: Point(22, 50)},
            hover: {sprite: 'md-hover', offset: Point(24, 56)},
        },
    },

    get(isDisabled, isHovered) {
        return this.config[isDisabled ? 'disabled' : 'medium'][
            isHovered ? 'hover' : 'default'
        ];
    },
};

export function Marker({
    location,
    isDisabled,
    isHovered,
    onClick,
    onMouseOver,
    onMouseOut,
    label,
}) {
    const {sprite, offset} = markerConfig.get(isDisabled, isHovered);
    const marketClasses = classNames('SpotMap-marker', {hover: isHovered});
    const labelClasses = classNames({hover: isHovered});

    return (
        <MapMarker
            className={marketClasses}
            longitude={location.longitude}
            latitude={location.latitude}
            offsetLeft={-offset.x}
            offsetTop={-offset.y}
        >
            <div
                onClick={onClick}
                onMouseOver={onMouseOver}
                onMouseOut={onMouseOut}
            >
                {!isDisabled && <Label className={labelClasses}>{label}</Label>}
                <Sprite name={sprite} />
            </div>
        </MapMarker>
    );
}

Marker.propTypes = {
    label: PropTypes.string.isRequired,
    location: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number,
    }).isRequired,
    isDisabled: PropTypes.bool,
    isHovered: PropTypes.bool,
    onClick: PropTypes.func,
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
};
